<template>
  <pt-life-experience-pavilion class="pt-life-experience-pavilion__withData" ref="table" @deleteLifeExperienceHallsList="deleteLifeExperienceHallsList"></pt-life-experience-pavilion>
</template>

<script>
import PtLifeExperiencePavilion from './index'
export default {
  name: 'pt-life-experience-pavilion__withData',
  components: {
    'pt-life-experience-pavilion': PtLifeExperiencePavilion
  },
  methods: {
    deleteLifeExperienceHallsList (id) {
      this.$store.dispatch('deleteLifeExperienceHallsList', id).then(res => {
        this.$message.success('删除生命体验馆成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除生命体验馆失败')
      })
    }
  }
}
</script>
